import { useAtom } from "@reatom/npm-react";
import { useCallback } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { productSamplesModalAtom } from "src/store/atoms";

import { ProductSamplesModal, ProductSamplesSheet } from "./components";

export const ResponsiveProductSamplesWidget = () => {
  const { isMobile } = useGravityDevice();

  const [productSamplesIsOpen, setProductSamplesIsOpen] = useAtom(
    productSamplesModalAtom,
  );

  const onClose = useCallback(() => {
    setProductSamplesIsOpen(false);
  }, [setProductSamplesIsOpen]);

  if (isMobile) {
    return (
      <ProductSamplesSheet open={productSamplesIsOpen} onClose={onClose} />
    );
  }
  return <ProductSamplesModal open={productSamplesIsOpen} onClose={onClose} />;
};
